jQuery(function ($) {
	$('.carousel').slick({
		autoplay: true,
		autoplaySpeed: 2000,
		slidesToShow: 5,
		infinite: true,
		slidesToScroll: 1,
		nextArrow:
			'<div class="carousel__next"><i class="fal fa-angle-right"></i></div>',
		prevArrow:
			'<div class="carousel__prev"><i class="fal fa-angle-left"></i></div>',
		useAutoplayToggleButton: false,
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});
});
